import { Provider } from '@angular/core';
import { FormGroupDirective, NgForm, UntypedFormControl } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

/**
 * Reward early, punish late. Material's default turns a field red as soon as it
 * has been touched, so tabbing past an empty required field scolds the user for
 * something they never attempted. This waits for a field to have been edited
 * *and* left, and shows everything that is still wrong once the form is
 * submitted; after that it keeps up live, so a fix clears the error at once.
 *
 * Only for forms that really submit (`ngSubmit`): where the save is a click
 * handler, `submitted` never turns true and errors would never appear. Add
 * LATE_ERROR_STATE to such a component's providers — not to a module, since
 * AuthModule is imported eagerly as well and its providers reach the whole app.
 */
export class EditedOrSubmittedErrorStateMatcher implements ErrorStateMatcher {
  public isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    if (!control?.invalid) {
      return false;
    }

    return (control.dirty && control.touched) || !!form?.submitted;
  }
}

export const LATE_ERROR_STATE: Provider = {
  provide: ErrorStateMatcher,
  useClass: EditedOrSubmittedErrorStateMatcher
};
